<app-modal [isOpen]="isOpen" title="Investment Overview" [showCancel]="false" doneLabel="Done" variant="investment"
    (done)="onDone()" (close)="onCancel()">
    <div class="investment-modal-content" *ngIf="!isLoading; else loadingState">
        <!-- Asset Header -->
        <div class="asset-header">
            <div class="asset-title-row">
                <h2 class="asset-name">{{ assetName }}</h2>
                <span class="trend-badge positive" [class.negative]="!apiData.assetInfo.isPositive">
                    <img src="assets/icons/up-trend.svg" alt="Arrow Up" class="investment-overview-widget__arrow-icon">
                    {{ apiData.assetInfo.trend }}
                </span>
            </div>
        </div>

        <!-- Balance Card -->
        <div class="balance-card">
            <div class="balance-item opening">
                <div class="label">Opening Balance</div>
                <div class="value-row">
                    <span class="value">{{ apiData.assetInfo.openingBalance | number:'1.0-0' }}</span>
                    <span class="currency">{{ apiData.assetInfo.currency }}</span>
                </div>
            </div>
            <div class="divider"></div>
            <div class="balance-item current">
                <div class="label-row">
                    <span class="label">Current Balance</span>
                    <span class="change positive" [class.negative]="!apiData.assetInfo.isPositive">
                        <img src="assets/icons/up-trend.svg" alt="Arrow Up"
                            class="investment-overview-widget__arrow-icon">
                        {{ apiData.assetInfo.change }} <span class="currency">₹</span>
                    </span>
                </div>
                <div class="value-row">
                    <span class="value">{{ apiData.assetInfo.currentBalance | number:'1.2-2' }}</span>
                    <span class="currency">{{ apiData.assetInfo.currency }}</span>
                </div>
            </div>
        </div>

        <!-- Segmented Control -->
        <div class="segmented-control">
            <button type="button" class="segment-btn" [class.active]="activeTab === 'daily'"
                (click)="onTabChange('daily')">
                DAILY
            </button>
            <button type="button" class="segment-btn" [class.active]="activeTab === 'monthly'"
                (click)="onTabChange('monthly')">
                MONTHLY
            </button>
            <button type="button" class="segment-btn" [class.active]="activeTab === 'weekly'"
                (click)="onTabChange('weekly')">
                WEEKLY
            </button>
            <button type="button" class="segment-btn" [class.active]="activeTab === 'annually'"
                (click)="onTabChange('annually')">
                ANNUALLY
            </button>
        </div>

        <!-- Chart Container -->
        <div class="chart-container">
            <div class="chart-wrapper">
                <canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="barChartType"
                    [plugins]="chartPlugins">
                </canvas>
            </div>
        </div>
    </div>

    <ng-template #loadingState>
        <div class="investment-loading">
            <div class="loader"></div>
            <p>Fetching account details...</p>
        </div>
    </ng-template>

</app-modal>